<template>
  <div class="discounts">
    <router-view></router-view>
  </div>
</template>

<script>
import store from '@/store';

export default {
  name: 'Discounts',
  beforeRouteEnter: (to, from, next) => {
    store.dispatch('fetchAllDiscounts').then(() => next());
  },
};
</script>

<style lang="scss" scoped>
.seasons {
  margin: 0 auto;
}
</style>
